// extracted by mini-css-extract-plugin
export default {"subProgressDetail":"request_return_subProgressDetail__Ui2wE"};